export const de = {
  auth: {
    signIn: "Login",
    resetPassword: "Passwort zurücksetzen",
    err: {
      invalid_grant: "Passwort oder Username falsch",
    },
  },
};
